import { render, staticRenderFns } from "./TopEntityComponentCalories.vue?vue&type=template&id=351ea59c&"
import script from "./TopEntityComponentCalories.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentCalories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports